import {
  DeleteSystemUserLinkRequest,
  DeleteSystemUserLinkRequestToJSON,
  HTTPBody,
  RegisterSystemUserLinkRequest,
  RegisterSystemUserLinkRequestToJSON,
  SystemUserLink,
  SystemUserLinkFromJSON,
  UpdateSystemUserLinkRequest,
  UpdateSystemUserLinkRequestToJSON
} from '@/api'
import * as runtime from '../runtime'

export class SystemUserLinkApi extends runtime.BaseAPI {
  /**
   * 外部リンクの一覧を取得する
   * 外部リンク一覧取得
   */
  async getSystemUserLinks(): Promise<SystemUserLink[]> {
    const response = await this.requestGet('/system-user-links')

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(SystemUserLinkFromJSON)
    ).value()
  }

  /**
   * 外部リンクを取得する
   * 外部リンク取得
   */
  async getSystemUserLink(id: string): Promise<SystemUserLink> {
    const response = await this.requestGet(`/system-user-links/${id}`)

    return new runtime.JSONApiResponse(response, jsonValue =>
      SystemUserLinkFromJSON(jsonValue)
    ).value()
  }

  /**
   * 外部リンクを更新する
   * 外部リンク更新
   */
  async updateSystemUserLink(
    request: UpdateSystemUserLinkRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = UpdateSystemUserLinkRequestToJSON(request)

    const response = await this.requestPut(
      `/system-user-links/${bodyParameters.id}`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 外部リンクを登録する
   * 外部リンク登録
   */
  async registerSystemUserLink(
    request: RegisterSystemUserLinkRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = RegisterSystemUserLinkRequestToJSON(
      request
    )

    const response = await this.requestPost(
      '/system-user-links',
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 外部リンクを削除する
   * 外部リンク削除
   */
  async deleteSystemUserLink(
    request: DeleteSystemUserLinkRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = DeleteSystemUserLinkRequestToJSON(request)

    const response = await this.requestDelete(
      `/system-user-links/${bodyParameters.id}`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }
}
